import { useState } from 'react'

import { Aside } from '../../components/layouts/Aside'
import { Content } from '../../components/layouts/Content'
import { Main } from '../../components/layouts/Main'
import { Page } from '../../components/layouts/Page'
import { AdviceSideBar } from '../../components/navigation/AdviceSideBar'
import { Brokers } from './painel-vendas/Brokers'
import { Production } from './painel-vendas/Production'
import { Products } from './painel-vendas/Products'

export const AdviceHome = (): JSX.Element => {
  const [totalFaturamentoMes, setTotalFaturamentoMes] = useState(0)
  return (
    <Page>
      <Content templateColumns="1fr 5fr">
        <Aside bg="#F8F8F8" pt="3rem" pl="1rem" align="baseline">
          <AdviceSideBar />
        </Aside>
        <Main p="3rem" align="flex-start" gap="5rem">
          <Products totalFaturamentoMes={totalFaturamentoMes} setTotalFaturamentoMes={setTotalFaturamentoMes} />
          <Production />
          <Brokers totalFaturamentoMes={totalFaturamentoMes} />
        </Main>
      </Content>
    </Page>
  )
}
